enum WorkspaceProjectLandUseStatus {
  'Draft' = 'Draft',
  'Published' = 'Published',
}

export default WorkspaceProjectLandUseStatus
